import "./Style.css";
import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import { PiUserCircleFill } from "react-icons/pi";
import LoginModal from "../LoginModal/LoginModal";
import { useEffect, useRef, useState } from "react";
import {
  Apiurl,
  ClearLocalStorage,
  clearLocalStorage,
  GetLocalStorageParsed,
  parseData,
  RemoveSession,
  SetLocalStorageStringify,
  stringifyData,
} from "../../Pages/utils/page";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { FaUser } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { BsFillTrophyFill } from "react-icons/bs";
import { IoIosWallet } from "react-icons/io";
import { FaUserCircle } from "react-icons/fa";
import { BsTags } from "react-icons/bs";
import { BsKanban } from "react-icons/bs";
import { BsBarChartSteps, BsFileEarmarkPerson } from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";
import { IoIosStar } from "react-icons/io";
import { BsCart } from "react-icons/bs";
import { IoIosLogOut } from "react-icons/io";
import { FaStar } from "react-icons/fa6";
import { GoCopy } from "react-icons/go";
import { toast } from "react-toastify";
import { BsPersonCircle } from "react-icons/bs";
import { BsFillBox2Fill } from "react-icons/bs";
import { ClipLoader } from "react-spinners";
import { BsPatchQuestion } from "react-icons/bs";
import { BsGraphUp } from "react-icons/bs";
import { BsQuestionDiamondFill } from "react-icons/bs";
import { BsBasket2 } from "react-icons/bs";
import { BsChatSquareText } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";


const Header = ({
  setLoginToken,
  setApiCallingOnLogin,
  apiCallingOnLogin,
  setCheckCartUpdateStatus,
  checkCartStatus,
  checkCartOrder,
  setCheckCartOrderStatus,
  cartItems,
  cartOrder,
  setCartOrder,
  setCartItems,
  cartOrderUpdate,
  setCartOrderUpdate,
  cartItemUpdate,
  setCartItemUpdate,
  setGoogleLogProductDetail,
  googleLogProductDetail,
  profileChange,
  setProfileChange,
  profileImage,
  profileData,
  setLoading,
  loading,
  imageUrlHeader,
  GetActiveCoupons,
  setGetProfielData,
  setAfterPaymentPointUpdate,
  afterPaymentPointUpdate,
  showLoginTrue,
  afterLoginToken,
}) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const FetchGoogleImage = GetLocalStorageParsed("googleImage");
  const getUser = GetLocalStorageParsed("UserDetail");
  const [loginTokenda, setLoginTokenda] = useState(FetchToken || null);
  const [emailActive, setEmailActive] = useState(true);
  const [UserPoints, setUserPoints] = useState("");
  const [cartItemlength, setCartitemLength] = useState();
  const [searchInput, setSearchInput] = useState();
  const [cartOrderlength, setCartOrderLength] = useState();
  const router = useNavigate();
  const [loginData, setLoginData] = useState();
  // const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [profileDataHeader, setProfileDataHeader] = useState([]);
  const [searchDropdownResult, setSearchDropdownResult] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [imageGoogle, setImageGoogle] = useState();

  const [scrollY, setScrollY] = useState(0); // Track scroll position
  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showLoading, setShowLoading] = useState("");
  const [inputData, setinputData] = useState({
    Email: "",
    Mobile: "",
    Otp: "",
  });
const [referalCode,setReferalCode]=useState(false);

  useEffect(() => {
    const header = headerRef?.current?.getBoundingClientRect();
    const handleScrollEvent = () => {
      setScrollY(window.pageYOffset); // Update scroll position
      // Compare scrollY with header position
      if (scrollY > header.top + header.height) {
        setSticky({ isSticky: true, offset: header.height });
      } else {
        setSticky({ isSticky: false, offset: 0 });
      }
    };
    window.addEventListener("scroll", handleScrollEvent); 
    // Cleanup event listener
    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, [scrollY]);
  const handleShow = () => {
    setShowLoginModal(true);
  };
  const handleClose = () => {
    setShowLoginModal(false);
    setReferalCode(false)
    setEmailActive(true);
  };
  const handleLogout = () => {
    ClearLocalStorage();
    setLoginTokenda();
    setLoginToken();
    // Clear state if needed
    setLoginData(null);
    const data = {};

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/LastSignOut`,
    };
    axios(options)
      .then((data) => {})
      .catch((error) => {});
    // Redirect to home page
    router("/");
  };
  // login api
  const loginApi = (userDetail) => {
    const data = {};
    data.email = userDetail?.email;
    data.name = userDetail?.name;
    data.image = userDetail?.picture;
    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/Login`,
    };
    axios(options)
      .then((data) => {
        const token = parseData(data?.data?.result);
        const user = jwtDecode(token?.Token);
        SetLocalStorageStringify("UserDetail", JSON.stringify(token));
        SetLocalStorageStringify("User", JSON.stringify(user));
        SetLocalStorageStringify("AuthToken", token?.Token);
        SetLocalStorageStringify("googleImage", userDetail?.picture);
        setImageGoogle(userDetail?.picture);

        setLoginData(token);

        setLoginTokenda(token?.Token);

        setLoginToken(token?.Token);

        setApiCallingOnLogin(true);

        setShowLoginModal(false);
    setReferalCode(false)


        setLoading("");
        GetActiveCoupons(token?.Token);
      })
      .catch((error) => {});
  };
  const handleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        { headers: { Authorization: `Bearer ${access_token}` } }
      );
      setShowLoginModal(false);
    setReferalCode(false)

      setLoading("mainLoader");
      loginApi(userInfo?.data);
      // SetLocalStorageStringify("googleData", userInfo?.data)
    },
  });
  const getProfile = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${
          loginTokenda || showLoginTrue || afterLoginToken || " "
        }`,
      },
      url: `${Apiurl()}/api/Customer/UserInfo`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const imageUrl = data?.Image?.split('"');
        setProfileDataHeader(data);
        if (imageUrl?.length) {
          const winnerImageUrl = `${Apiurl()}/${imageUrl?.[1]}`;
          setImageUrl(winnerImageUrl);
        }
        setGetProfielData(data);
        setProfileChange(false);
        setAfterPaymentPointUpdate(false);
      })
      .catch((error) => {
        // if (error?.code === "ERR_BAD_REQUEST") {
        //   RemoveSession(router);
        // }
      });
  };
  useEffect(() => {
    if (
      loginTokenda ||
      profileChange ||
      afterPaymentPointUpdate ||
      profileData ||
      showLoginTrue
    ) {
      getProfile();
    }
  }, [
    loginTokenda,
    profileChange,
    afterPaymentPointUpdate,
    profileData,
    showLoginTrue,
  ]);
  // get user points

  // get all cart
  const handleGetAllCart = (item) => {
    const data = {
      data: null,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Cart/GetAll`,
    };
    axios(option)
      .then((e) => {
        setCartitemLength(parseData(e?.data?.result)?.length);
        setCartItemUpdate(false);
        setCartItems(parseData(e?.data?.result));
        setCheckCartUpdateStatus(false);
      })
      .catch((error) => {});
  };
  // get all Order
  const handleGetAllOrder = (item) => {
    const option = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      url: `${Apiurl()}/api/Order/GetAll`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setCartOrderLength(parseData(e?.data?.result)?.length);
        setCartOrderUpdate(false);
        const dataformat = data?.map((item) => ({
          ...item,
          selectedQuantity: item?.Quantity,
        }));
        setCartOrder(dataformat);
        setCheckCartOrderStatus(false);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    if (loginTokenda) {
      handleGetAllCart();
      handleGetAllOrder();
    }
  }, [loginTokenda]);
  useEffect(() => {
    if (
      checkCartStatus === true ||
      checkCartOrder === true ||
      cartOrderUpdate === true ||
      cartItemUpdate === true
    ) {
      handleGetAllCart();
      handleGetAllOrder();
    }
  }, [checkCartStatus, checkCartOrder, cartOrderUpdate, cartItemUpdate]);
  const handleCopyUrl = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const urlWithReferral = `${baseUrl}/referralcode/${
      JSON.parse(getUser)?.ReferralCode
    }`;
    navigator.clipboard.writeText(urlWithReferral);
    toast.success("Referral Link Copied!!");
  };

  const handleSendOtp = (e) => {
    setShowLoading("otpsent");

    const data = {};
    if (emailActive) {
      data.Name=null;

      data.PhoneNumber = null;
      data.OTP=null;


      data.Email = inputData?.Email;
      data.IsManual = true;
      data.ReferByUserCode=null

    } else {
      data.PhoneNumber = Number(`91${inputData?.Mobile}`);
      data.IsManual = true;
      data.Name=null;
      data.Email=null;
      data.OTP=null;
      data.ReferByUserCode=null

    }

    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/Login`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setShowLoading("");
        setShowOtpInput(true);
      })
      .catch((error) => {
        setShowLoading("");
      });
  };
  const handleSubmitOtp = (e) => {
    setShowLoading("submitotp");

    const data = {};
    if (emailActive) {
      data.Email = inputData?.Email;
      data.IsManual = true;
      data.Otp = inputData?.Otp;
    } else {
      data.phoneNumber = Number(`91${inputData?.Mobile}`);
      data.Otp = inputData?.Otp;
    }
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/Login`,
    };
    axios(option)
      .then((e) => {
        const token = parseData(e?.data?.result);
        const user = jwtDecode(token?.Token);
        setShowOtpInput(false);
        setEmailActive(true);
        setinputData({
          Email: "",
          Mobile: "",
          Otp: "",
        });

        SetLocalStorageStringify("UserDetail", JSON.stringify(token));
        SetLocalStorageStringify("User", JSON.stringify(user));
        SetLocalStorageStringify("AuthToken", token?.Token);
        // SetLocalStorageStringify("googleImage", userDetail?.picture);
        // setImageGoogle(userDetail?.picture)
        setLoginData(token);
        setLoginTokenda(token?.Token);
        setLoginToken(token?.Token);
        setApiCallingOnLogin(true);
        setShowLoginModal(false);
    setReferalCode(false)

        GetActiveCoupons(token?.Token);
        setShowLoading("");
      })
      .catch((error) => {
        setShowLoading("");
      });
  };
  const handleSearchAPi = (text) => {
    setShowLoading("submitotp");

    const data = {
      text: text,
    };

    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/SearchAsync`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setSearchDropdownResult(data);
      })
      .catch((error) => {
        setShowLoading("");
      });
  };
  return (
    <>
      <div
        className={`header_main ${sticky.isSticky ? "sticky" : ""}`}
        ref={headerRef}
      >
        <Navbar expand="lg" className="header_nav">
          <div className="container header_pd_12">
            <Navbar.Brand className="header_logo">
              <NavLink to="/" className="header_logo navbar-brand">
                <img src="/Images/ShopLogo.svg" alt="Shopsaverz Logo" />
              </NavLink>
            </Navbar.Brand>

            <div className="header_all_val">
              <div className="form-group has-search searchbar-visible">
                {/* <IoSearch className="search-icon-header"
                style={{ right: searchInput ? "25px" : "14px" }}
                
                />

                <input
                  type="text"
                  className="form-control"
                  placeholder="Type Product or Merchant name..."
                  value={searchInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchInput(value);
                    if (value.length >= 3) {
                      handleSearchAPi(value); // Pass value directly
                    }
                  }}
                />
                {searchInput && 
                
                <RxCross2 className="cross-icon" onClick={()=>{
                  setSearchInput("");
                  setSearchDropdownResult([]);

                }}/>
                } */}

                {searchDropdownResult?.length > 0 && (
                  <div id="dropdown" className="search-suggestoin">
                    {searchDropdownResult?.map((item, index) => (
                      <div
                        key={item.ProductId || index}
                        style={{ padding: "8px", cursor: "pointer",color:"black" }}
                      >
                        {item.ProductName}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {loginData || loginTokenda || showLoginTrue ? (
                <>
                  <div className="UserPoints-container">
                    {" "}
                    <FaStar />
                    <p>Points</p>{" "}
                    <span>{profileDataHeader?.BalancePoint} </span>{" "}
                  </div>
                  <div className="nav-item rounded gap-nav">
                    <NavLink
                      to="/cartdetails"
                      className="nav-link cart_icon_top"
                    >
                      <BsCart className="bi bi-cart" />
                      <span>
                        {cartItemlength || cartOrderlength
                          ? cartItemlength + cartOrderlength
                          : "0"}
                      </span>
                    </NavLink>
                  </div>
                  <NavDropdown
                    title={
                      <>
                        <img
                          src={
                            imageUrlHeader ||
                            imageUrl ||
                            imageGoogle ||
                            FetchGoogleImage ||
                            "/Images/unisexImage.jpeg"
                          }
                          alt="Shopsaverz Logo"
                          className="login_profile_img"
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = "/Images/unisexImage.jpeg";
                          }}
                        />
                      </>
                    }
                    id="basic-nav-dropdown"
                    className="header_dropdown"
                  >
                    {profileDataHeader?.IsSuperAdmin ? (
                      <>
                        {/* <NavLink to="/defaultsetting" className='header_dropdown_links'><IoSettingsOutline />Default Setting</NavLink> */}
                        <NavLink
                          to="/defaultsetting"
                          className="header_dropdown_links"
                        >
                          <IoSettingsOutline />
                          Admin Dashboard
                        </NavLink>
                      </>
                    ) : null}
                    {profileDataHeader?.IsInBusiness ? (
                      <>
                        <NavLink
                          to="/uploadandlisting"
                          className="header_dropdown_links"
                        >
                          <BsTags />
                          Products
                        </NavLink>
                        <NavLink
                          to="/banneranalytic"
                          className="header_dropdown_links"
                        >
                          <BsGraphUp />
                          Analytics
                        </NavLink>
                        <NavLink
                          to="/customerqueries"
                          className="header_dropdown_links"
                        >
                          <BsPatchQuestion />
                          Queries
                        </NavLink>
                        <NavLink
                          to="/customerorders"
                          className="header_dropdown_links"
                        >
                          <BsBasket2 />
                          Customer Orders
                        </NavLink>
                        <NavLink
                          to="/promotionalbannerquerylist"
                          className="header_dropdown_links"
                        >
                          <BsQuestionDiamondFill />
                          Promotional Queries
                        </NavLink>
                      </>
                    ) : null}

                    <NavLink to="/profile" className="header_dropdown_links">
                      <FaUserGroup />
                      Profile
                    </NavLink>
                    <NavLink to="/winning" className="header_dropdown_links">
                      <BsFillTrophyFill />
                      Winners
                    </NavLink>
                    <NavLink
                      to="/festivalWinnersGift"
                      className="header_dropdown_links"
                    >
                      <BsFillTrophyFill />
                      Event Winners
                    </NavLink>
                    <NavLink to="/blogs" className="header_dropdown_links">
                      <BsChatSquareText />
                      Blogs
                    </NavLink>
                    <NavLink to="/orders" className="header_dropdown_links">
                      <BsFillBox2Fill />
                      Order
                    </NavLink>
                    <NavLink to="/wallet" className="header_dropdown_links">
                      <IoIosWallet />
                      Wallet
                    </NavLink>
                    <NavLink
                      to="/referralsprogram"
                      className="header_dropdown_links"
                    >
                      <BsKanban />
                      Referral
                    </NavLink>
                    <div
                      onClick={handleCopyUrl}
                      className="header_dropdown_links"
                    >
                      <GoCopy />
                      Copy Referral Link
                    </div>
                    <div
                      className="header_dropdown_links"
                      onClick={handleLogout}
                    >
                      <IoIosLogOut />
                      Logout
                    </div>
                  </NavDropdown>
                </>
              ) : (
                <>
                  <NavLink
                    to=""
                    className="header_dropdown_links login_but"
                    onClick={handleShow}
                  >
                    <BsPersonCircle className="login_butt_icon" />
                    Login
                  </NavLink>
                </>
              )}
            </div>
            {/* </Navbar.Collapse> */}
          </div>
        </Navbar>
        <LoginModal
          showLoginModal={showLoginModal}
          setShowLoginModal={setShowLoginModal}
          handleClose={handleClose}
          handleLogin={handleLogin}
          inputData={inputData}
          setinputData={setinputData}
          setEmailActive={setEmailActive}
          emailActive={emailActive}
          handleSendOtp={handleSendOtp}
          showOtpInput={showOtpInput}
          handleSubmitOtp={handleSubmitOtp}
          showLoading={showLoading}
          setReferalCode={setReferalCode}
referalCode={referalCode}
        />
      </div>
    </>
  );
};
export default Header;
